import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';

import { Box, TextField, styled } from '@mui/material';
import { UserData } from '@codefluegel/wowis-rest-typescript-client';

const StyledTextField = styled(TextField)({
  input: { color: '#58585A' },
  marginBottom: '0.9rem',
  '& .MuiInputLabel-root': { fontSize: '0.9rem' },
});

interface PersonalData extends UserData {
  zipCode?: string;
  location?: string;
  street?: string;
  adressInfo?: string;
  door?: string;
}

export interface GetFormHandle {
  getFormState: () => PersonalData;
}
interface Props {
  user: UserData | undefined;
  onChange: () => void;
}

const PersonDataForm = forwardRef<GetFormHandle, Props>((props, ref) => {
  const { user, onChange } = props;

  const [firstname, setFirstname] = useState(user?.firstname || '');
  const [lastname, setLastname] = useState(user?.lastname || '');
  const [zipCode, setZipCode] = useState(user?.zustelladresse?.plz || '');
  const [location, setLocation] = useState(user?.zustelladresse?.city || '');
  const [street, setStreet] = useState(user?.zustelladresse?.street || '');
  // const [adressInfo, setAdressInfo] = useState('');
  // const [door, setDoor] = useState('');
  const isEbgClient = process.env.REACT_APP_CLIENT?.includes('ebg') || false;

  useEffect(() => {
    setFirstname(user?.firstname || '');
    setLastname(user?.lastname || '');
    setZipCode(user?.zustelladresse?.plz || '');
    setLocation(user?.zustelladresse?.city || '');
    setStreet(user?.zustelladresse?.street || '');
  }, [user]);

  // useImperativeHandle for all the state values
  useImperativeHandle(ref, () => ({
    getFormState: () => ({
      firstname,
      lastname,
      zipCode,
      location,
      street,
      // adressInfo,
      // door,
    }),
  }));

  return (
    <Box
      component="form"
      display="flex"
      flexDirection="column"
      noValidate
      autoComplete="off"
      width={1}
      height={1}
      p={3}
    >
      <StyledTextField
        id="firstname"
        label="VORNAME"
        variant="standard"
        disabled
        value={firstname}
        onChange={e => {
          setFirstname(e.target.value);
          onChange();
        }}
      />
      <StyledTextField
        id="lastname"
        label="NACHNAME"
        variant="standard"
        value={lastname}
        disabled
        onChange={e => {
          setLastname(e.target.value);
          onChange();
        }}
      />
      {user?.firstname2 && (
        <StyledTextField
          id="firstname2"
          label="VORNAME 2"
          variant="standard"
          disabled
          value={user?.firstname2}
        />
      )}
      {user?.lastname2 && (
        <StyledTextField
          id="lastname2"
          label="NACHNAME 2"
          variant="standard"
          disabled
          value={user?.lastname2}
        />
      )}
      {user?.zustelladresse && (
        <>
          <Box display="flex">
            <Box>
              <StyledTextField
                id="zipCode"
                label="PLZ"
                variant="standard"
                disabled={isEbgClient}
                value={zipCode}
                onChange={e => {
                  setZipCode(e.target.value);
                  if (!isEbgClient) onChange();
                }}
              />
            </Box>
            <Box width={20} />
            <Box width={1}>
              <StyledTextField
                fullWidth
                id="location"
                label="ORT"
                variant="standard"
                disabled={isEbgClient}
                value={location}
                onChange={e => {
                  setLocation(e.target.value);
                  if (!isEbgClient) onChange();
                }}
              />
            </Box>
          </Box>
          <StyledTextField
            id="street"
            label="STRASSE"
            variant="standard"
            disabled={isEbgClient}
            value={street}
            onChange={e => {
              setStreet(e.target.value);
              if (!isEbgClient) onChange();
            }}
          />
          {/*
      <StyledTextField
        id="adressinfo"
        label="ADRESSZUSATZ"
        variant="standard"
        value={adressInfo}
        onChange={e => {
          setAdressInfo(e.target.value);
          onChange();
        }}
      />
      <StyledTextField
        id="adressinfo"
        label="TÜR"
        variant="standard"
        value={door}
        onChange={e => {
          setDoor(e.target.value);
          onChange();
        }}
      />
      */}
        </>
      )}
    </Box>
  );
});

export default PersonDataForm;
